import { render } from "./CategoryListPage.vue?vue&type=template&id=131f0e95"
import script from "./CategoryListPage.vue?vue&type=script&lang=js"
export * from "./CategoryListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__